import { Tab, Tabs, TabList, TabPanel } from 'react-tabs';

import styles from './styles.module.scss';
import { UserAdmin } from '../../components/admin/UserAdmin';
import { CatgAdmin } from '../../components/admin/CatgAdmin';
import { ArticleAdmin } from '../../components/admin/ArticleAdmin';
import { useUser } from '../../hooks/useLogin';

import './tabs.scss'
import { useEffect, useState } from 'react';
import { api } from '../../services/api';

export function Admin() {

    const { userStatus } = useUser()
    const [logado, setLogado] = useState(false)
    const [carregando,setCarregando] = useState(true)
    

    const user = JSON.parse(localStorage.getItem('userData') || '{}')

    useEffect(() => {
        async function validateToken() {
            let result = await api.post('/validateToken', user)                        
            setLogado(result.data)
            setCarregando(false)
        }

        validateToken()

    }, [])

    if (carregando){
        return (
            <h4>Carregando....</h4>
        )
    }

    if (logado === false) {
        window.location.pathname = `${process.env.REACT_APP_BASE_URL}/login`
    }


    if (userStatus === false) {
        console.log('if false')
        return (
            <div className={styles.Main}>
              <div className={styles.contentContainer}> 
                 Não logado. Redirecionando...
              </div>
            </div> 
        )
    }else{
        console.log('if true')
        return (
            <div className={styles.Main}>
                <div className={styles.contentContainer}>
                    <div className={styles.bgTabsStyle}>
                        <Tabs>
                            <TabList>
                                <Tab><h2 className="tab-title">Artigos</h2></Tab>
                                <Tab><h2 className="tab-title">Categorias</h2></Tab>
                                <Tab><h2 className="tab-title">Usuários</h2></Tab>
                            </TabList>
                            <TabPanel>
                                <ArticleAdmin />
                            </TabPanel>
                            <TabPanel>
                                <CatgAdmin />
                            </TabPanel>
                            <TabPanel>
                                <UserAdmin />
                            </TabPanel>
                        </Tabs>
                    </div>
                </div>
            </div>
        )
    }
}